export type SpinnerSize = "sm" | "md" | "lg";

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: "size-4 border-2",
  md: "size-6 border-[2.5px]",
  lg: "size-9 border-[3px]",
};

export interface SpinnerProps {
  size?: SpinnerSize;

  "aria-label"?: string;
}

export function Spinner({ size = "md", "aria-label": ariaLabel = "Loading" }: Readonly<SpinnerProps>) {
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={[
        "inline-block animate-[spin_0.8s_linear_infinite] rounded-full border-surface-tertiary border-t-brand-primary",
        SIZE_CLASSES[size],
      ].join(" ")}
    />
  );
}
